import { Component, Input, SimpleChanges, Output, EventEmitter, HostListener } from '@angular/core';
import Chart from 'chart.js/auto';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DataPoint, NtChartRegionInterface, StartingPoint } from '../../../../../../shared/interfaces/nt-chart-region.interface';
import { ModalOpenToMarketCurveComponent } from "../modal-open-to-market-curve/modal-open-to-market-curve.component";
import { CommonModule } from '@angular/common';

type Pt = { month: string | Date; value: number };

@Component({
  selector: 'app-open-to-market-curve',
  imports: [ModalOpenToMarketCurveComponent, CommonModule],
  templateUrl: './open-to-market-curve.component.html',
  styleUrl: './open-to-market-curve.component.css',
  host: { style: 'display: block; height: 100%; width: 100%;' }  // to ensure the component fills the card area
})
export class OpenToMarketCurveComponent {

  public chart: any;
  public hasData: boolean = false;

  public chartData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: []
  };

  @Input() lineColor1: string | undefined;
  @Input() lineColor2: string | undefined;
  // title selected in the card-widget header (displayedTitle), shown in the modal
  @Input() widgetTitle: string = '';
  @Output() hasOpenToMarketCurveData = new EventEmitter<boolean>();


  curvePointData: any = {};
  isMarketCurveOpen: boolean = false;

  overlappingCandidates: any[] = [];
  isOverlapChoiceOpen: boolean = false;
  overlapChoicePosition: { x: number; y: number } = { x: 0, y: 0 };

  private readonly OVERLAP_THRESHOLD_BREAKPOINT = 1516;
  private readonly OVERLAP_THRESHOLD_PERCENT_SMALL = 5;
  private readonly OVERLAP_THRESHOLD_PERCENT_LARGE = 2;

  public medicineId = 0;
  public countryId = 1;

  public chartInstances: Chart[] = [];
  public chartContext: any;
  public chartId: string;

  public isTabletView: boolean = false;
  totalMonths: number = 0;

  overlapMenuAlign: string = "right"; // default alignment

  constructor(private dataService: DataService) {
    this.chartId = 'chart_' + Math.random().toString(36).substring(2, 9);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isOverlapChoiceOpen) {
      const target = event.target as HTMLElement;
      const dropdownElement = document.querySelector('.overlap-dropdown-menu');
      if (dropdownElement && !dropdownElement.contains(target)) {
        this.closeOverlapChoice();
      }
    }
  }

  ngAfterViewInit(): void {
    this.medicineId = sessionStorage.getItem('medicineId') ? Number(sessionStorage.getItem('medicineId')) : 0;
    this.countryId = sessionStorage.getItem('countryId') ? Number(sessionStorage.getItem('countryId')) : 1;
    this.isTabletView = window.innerWidth < 1526; // TABLET VIEW
    window.addEventListener('resize', () => this.onResize());

    this.loadChartData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['medicineId']) {
      this.loadChartData();  // Ricarica il grafico quando cambia il medicineId o countryId
    }
  }

  ngOnDestroy(): void {
    this.destroyCharts();
  }

  private onResize(): void {
    const newWidth = window.innerWidth;
    const wasTablet = this.isTabletView;
    this.isTabletView = newWidth < 1526; // TABLET VIEW

  }

  loadChartData(): void {
    setTimeout(() => {
      /*this.dataService.getNationalMarketChart(this.medicineId, this.countryId).subscribe(data => {
        // verify data
        this.hasData = data?.labels?.length > 0 &&
          (data.real.some((val: any) => val !== null) ||
            data.target.some((val: any) => val !== null));

        if (!this.hasData) {
          this.destroyCharts();
          this.createEmptyChart();
          return;
        }*/

      /*this.chartData = {
        ...data,
        labels: data.labels.map((label: string) => {
          const [year, month] = label.split('-');
          return `${month}-${year}`;
        })
      };*/

      /*this.chartData = data

      console.log('chart data', this.chartData);


      this.destroyCharts();
      this.createChart();
    });*/

      this.dataService.getOpenToMarketChartInfo(this.medicineId, this.countryId).subscribe(infoData => {
        // verify data
        this.hasData = infoData?.labels?.length > 0 &&
          (infoData.actual.some((val: any) => val !== null) ||
            infoData.target.some((val: any) => val !== null));
        // USE THIS TO SIMULATE NO DATA SCENARIO
        // this.hasData=false;
        if (!this.hasData) {
          this.hasOpenToMarketCurveData.emit(false);
          this.destroyCharts();
          this.createEmptyChart();
          return;
        }

        this.hasOpenToMarketCurveData.emit(true);
        this.chartData = infoData
        this.destroyCharts();
        this.createChart();
      });

    });
  }

  private createEmptyChart(): void {
    const chartCanvas = document.getElementById(this.chartId) as HTMLCanvasElement;
    if (!chartCanvas) return;

    chartCanvas.style.width = '100%';
    chartCanvas.style.height = '280px';
    chartCanvas.style.minWidth = '300px';

    this.chartContext = chartCanvas.getContext('2d');

    const emptyChart = new Chart(this.chartContext, {
      type: 'line',
      data: {
        labels: ['', '', '', '', '', ''],
        datasets: [
          {
            label: "\u00A0Actual",
            data: [null, null, null, null, null, null],
            borderColor: 'rgba(0, 128, 255, 0.2)',
            backgroundColor: 'rgba(0, 128, 255, 0.1)',
            borderWidth: 2,
            tension: 0.2,
            pointRadius: this.isTabletView ? 3.6 : 4.5,
            pointHoverRadius: this.isTabletView ? 5.5 : 7.5,
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2,
            spanGaps: false,
            clip: false,
            fill: false
          },
          {
            label: "\u00A0Forecast\u00A0\u00A0\u00A0\u00A0",
            data: [null, null, null, null, null, null],
            borderColor: 'rgba(255, 165, 0, 0.2)',
            backgroundColor: 'rgba(255, 165, 0, 0.1)',
            borderWidth: 2,
            tension: 0.2,
            pointRadius: this.isTabletView ? 3.6 : 4.5,
            pointHoverRadius: this.isTabletView ? 5.5 : 7.5,
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2,
            spanGaps: false,
            clip: false,
            fill: false
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: { enabled: false }
        },
        scales: {
          x: {
            display: true,
            grid: {
              display: false,
              drawOnChartArea: false,
              drawTicks: false
            },
            ticks: {
              display: false
            },
            border: {
              display: false
            }
          },
          y: {
            display: true,
            min: 0,
            max: 100,
            ticks: {
              stepSize: 10,
              font: {
                size: this.isTabletView ? 6 : 8,
                family: 'Montserrat, sans-serif'
              },
              color: 'rgba(0,0,0,0.2)',
              callback: (val) => val + '%'
            },
            grid: {
              display: true,
              color: 'rgba(0,0,0,0.05)',
              drawTicks: false,
              lineWidth: 1
            },
            border: {
              display: false
            }
          }
        },
        onClick: () => false,
        elements: {
          line: {
            borderWidth: 2
          },
          point: {
            radius: 0
          }
        },
        layout: {
          padding: {
            top: 10,
            bottom: 10
          }
        }
      }
    });

    this.chartInstances.push(emptyChart);
  }


  createChart() {
    const chartCanvas = document.getElementById(this.chartId) as HTMLCanvasElement;

    this.totalMonths = this.chartData.labels?.length || 0;
    if (!chartCanvas) {
      console.error("Elemento canvas non trovato");
      return;
    } else {
      this.chartContext = chartCanvas.getContext("2d");
    }

    if (!this.chartData || !this.chartData.labels || this.chartData.labels.length === 0) {
      const chartEmptyInstance = new Chart(this.chartContext, {
        type: 'line',
        data: {
          labels: ['Nessun Dato'],
          datasets: [
            {
              label: '',
              data: [],
              backgroundColor: ['#d3d3d3'],
              borderWidth: 1,
              clip: false
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          aspectRatio: 5.0,
          plugins: {
            legend: {
              display: false
            }
          },
          scales: {
            y: {
              display: true,
              title: {
                display: false,
                text: 'Valori'
              },
              min: 0,
              max: 100,
              ticks: {
                callback: function (data, index, values) {
                  return data + '%';
                },
                font: {
                  size: this.isTabletView ? 6 : 8,
                  family: 'Montserrat, sans-serif'
                },
                stepSize: 10,
                maxTicksLimit: 11
              },
              suggestedMin: 0,
              suggestedMax: 100,
              grid: {
                display: true
              },
              border: {
                display: false
              },
            }
          }
        }
      });


      this.chartInstances.push(chartEmptyInstance);
      console.error("Dati non disponibili.");
      return;
    }

    // --- helpers ---
    const toYm = (input: string | Date): string => {
      if (input instanceof Date && !isNaN(input.getTime())) {
        const y = input.getFullYear();
        const m = String(input.getMonth() + 1).padStart(2, '0');
        return `${y}-${m}`;
      }
      const raw = String(input).trim();
      // Accept YYYY-MM, YYYYMM, YYYY-MM-DD, YYYYMMDD
      const m = raw.match(/^(\d{4})-?(\d{2})(?:-?\d{2})?$/);
      if (!m) throw new Error(`Bad month format: ${raw}`);
      return `${m[1]}-${m[2]}`;
    };

    const ymToNum = (ym: string) => {
      const [y, m] = ym.split('-').map(Number);
      return y * 100 + m;
    };

    const sortLabelsChrono = (labels: string[]) =>
      [...labels].map(toYm).sort((a, b) => ymToNum(a) - ymToNum(b));

    const accumulate = (points: Pt[]) => {
      const sums = new Map<string, number>();
      for (const p of points) {
        const k = toYm(p.month);
        // 👇 ARROTONDA OGNI VALORE A 2 DECIMALI PRIMA DI SOMMARLO
        const roundedValue = Math.round(Number(p.value) * 100) / 100;
        sums.set(k, (sums.get(k) ?? 0) + roundedValue);
      }
      const months = [...sums.keys()].sort((a, b) => ymToNum(a) - ymToNum(b));
      const acc = new Map<string, number>();
      let running = 0;
      for (const m of months) {
        running += sums.get(m)!;
        running = Math.round(running * 100) / 100;
        acc.set(m, running);
      }
      return acc;
    };

    const firstMonthNum = (acc: Map<string, number>) => {
      if (acc.size === 0) return null;
      const mins = Math.min(...[...acc.keys()].map(ymToNum));
      return mins;
    };

    const buildSeries = (
      labels: string[],
      acc: Map<string, number>,
      carryForward: boolean,
      maxMonthNum?: number, // for Actual: stop at current month
      stopAt100?: boolean,  // for Actual: stop inserting points once value reaches 100
    ): (number | null)[] => {
      const startNum = firstMonthNum(acc);
      const out: (number | null)[] = [];
      let last: number | undefined;
      let reachedMax = false;

      for (const label of labels) {
        const num = ymToNum(label);

        if (startNum == null || num < startNum) {
          out.push(null);
          continue;
        }
        if (maxMonthNum != null && num > maxMonthNum) {
          out.push(null);
          continue;
        }
        if (stopAt100 && reachedMax) {
          out.push(null);
          continue;
        }

        const v = acc.get(label);
        if (v != null) {
          out.push(v);
          last = v;
          if (stopAt100 && v >= 100) reachedMax = true;
        } else if (carryForward && last != null) {
          out.push(last);
          if (stopAt100 && last >= 100) reachedMax = true;
        } else {
          out.push(null);
        }
      }
      return out;
    };

    /*const currentDate = new Date();
    const currentYearMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;

    // Find the index up to the current month in the labels array
    const endIndex = this.chartData.labels.findIndex((label: string) => label === currentYearMonth) + 1;

    // Slice the real values up to the current month, and pad with `null` for future months
    const filteredReal = [
      ...this.chartData.real.slice(0, endIndex),
      ...Array(this.chartData.real.length - endIndex).fill(null) // Fills future months with null
    ];*/

    const labelsRaw: string[] = this.chartData.labels || [];
    const labels = sortLabelsChrono(labelsRaw); // ensure chronological order

    const targetAcc = accumulate(this.chartData.target || []);
    const actualAcc = accumulate(this.chartData.actual || []);

    // current month as YYYY-MM number
    const now = new Date();
    const currentNum = ymToNum(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`);

    // Carry-forward keeps the line flat through months without data
    const targetValues = buildSeries(labels, targetAcc, /*carryForward*/ true);
    const actualValues = buildSeries(labels, actualAcc, /*carryForward*/ true, /*maxMonthNum*/ currentNum, /*stopAt100*/ true);

    // Optional: maps with original (non-cumulative) values for tooltips
    const originalTargetMap = new Map<string, number>();
    (this.chartData.target || []).forEach(p => originalTargetMap.set(toYm(p.month), Number(p.value)));

    const originalActualMap = new Map<string, number>();
    (this.chartData.actual || []).forEach(p => originalActualMap.set(toYm(p.month), Number(p.value)));

    const chartInstance = new Chart(this.chartContext, {
      type: 'line',
      data: {
        labels: this.chartData.labels, // Assuming labels for X-axis
        datasets: [
          {
            label: "\u00A0Actual",
            data: actualValues,
            borderColor: this.lineColor1,
            backgroundColor: this.lineColor1,
            borderWidth: 2,
            clip: false,
            fill: false,
            tension: 0.2,
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2,
            pointRadius: this.isTabletView ? 4.3 : 5,
            pointHoverRadius: this.isTabletView ? 6.5 : 7.5,
            pointHitRadius: this.isTabletView ? 15 : 13,
            spanGaps: false
          },
          {
            label: "\u00A0Forecast\u00A0\u00A0\u00A0\u00A0",
            data: targetValues,
            borderColor: this.lineColor2,
            backgroundColor: this.lineColor2,
            borderWidth: 2,
            clip: false,
            fill: false,
            tension: 0.2,
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2,
            pointRadius: this.isTabletView ? 4.3 : 5,
            pointHoverRadius: this.isTabletView ? 6.5 : 7.5,
            pointHitRadius: this.isTabletView ? 15 : 13,
            spanGaps: false
          },
        ]
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: false,
            position: 'top',
            align: 'center',
            reverse: true,

            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              boxWidth: 8,
              boxHeight: 8,
              font: {
                size: 13,
                family: 'Montserrat, sans-serif'
              },
              color: "#000",
            },

          },
          tooltip: {
            callbacks: {
              title: function () {
                return '';
              },
              label: function (context) {
                const label = context.dataset.label || '';
                const value = Number(context.raw);
                return ` ${value.toFixed(2)}%`;
              }
            }
          }
        },
        scales: {
          x: {
            display: true, // Mostra l'asse X
            title: {
              display: false, // Mostra il titolo sull'asse X
              text: 'Mesi' // Testo del titolo sull'asse X
            },
            grid: {
              display: false, // Nascondi le linee della griglia verticali
              lineWidth: 0,
              color: 'rgba(0, 0, 0, 0)',
              drawOnChartArea: false,
            },
            ticks: {
              callback: function (value: any) {
                const label = this.getLabelForValue
                  ? this.getLabelForValue(value)
                  : value;

                if (typeof label !== 'string') return label;

                // labels are "YYYY-MM": month on top, year below
                const [year, month] = label.split(/[\s/-]+/);
                if (!month || !year) return label;

                return [month, year]; // Multiline
              },
              font: {
                size: this.isTabletView ? (this.totalMonths > 15 ? 6.6 : 7) : 9,
                family: 'Montserrat, sans-serif'
              },
            },
          },
          y: {
            display: true, // Mostra l'asse Y
            title: {
              display: false, // Mostra il titolo sull'asse Y
              text: 'Valori' // Testo del titolo sull'asse Y
            },
            min: 0,
            max: 100,
            ticks: {
              callback: function (data, index, values) {
                return data + '%'; // Converti il valore decimale in percentuale e aggiungi il simbolo "%"
              },
              font: {
                size: this.isTabletView ? 7 : 9,  // Imposta il font-size delle etichette
                family: 'Montserrat, sans-serif'
              },
              stepSize: 10,
              maxTicksLimit: 11
            },
            suggestedMin: 0,
            suggestedMax: 100,
            grid: {
              display: true
            },
            border: {
              display: false
            },
          }
        },
        onClick: (event, elements) => {
          if (elements.length === 0) return;

          const clickedElement = elements[0];
          const datasetIndex = clickedElement.datasetIndex;
          const dataIndex = clickedElement.index;

          if (!this.chartData.labels || dataIndex >= this.chartData.labels.length) return;

          const label = this.chartData.labels[dataIndex];
          const monthFormatted = label.substring(5, 7) + '-' + label.substring(0, 4);

          const actualVal = actualValues[dataIndex];
          const targetVal = targetValues[dataIndex];

          const clickedCandidate = {
            type: datasetIndex === 0 ? 'Actual' : 'Forecast',
            month: monthFormatted,
            value: datasetIndex === 0 ? actualVal : targetVal,
          };

          const otherCandidate = {
            type: datasetIndex === 0 ? 'Forecast' : 'Actual',
            month: monthFormatted,
            value: datasetIndex === 0 ? targetVal : actualVal,
          };

          const bothValuesExist =
            actualVal !== null && actualVal !== undefined &&
            targetVal !== null && targetVal !== undefined;

          const difference = bothValuesExist
            ? Math.abs((actualVal as number) - (targetVal as number))
            : Infinity;

          if (bothValuesExist && difference <= this.getOverlapThresholdPercent()) {
            this.overlappingCandidates = [clickedCandidate, otherCandidate];
            const isLastPoint = dataIndex >= (this.chartData.labels?.length ?? 0) - 2;
this.overlapMenuAlign = isLastPoint ? 'right' : 'left';
            this.overlapChoicePosition = {
              x: (event.native as MouseEvent)?.offsetX ?? 0,
              y: (event.native as MouseEvent)?.offsetY ?? 0,
            };
            this.isOverlapChoiceOpen = true;
            this.isMarketCurveOpen = false;
          } else {
            this.curvePointData = clickedCandidate;
            this.isOverlapChoiceOpen = false;
            this.isMarketCurveOpen = true;
          }
        }
      }
    });
    this.chartInstances.push(chartInstance);
  }

  toYearMonthNumber(label: string): number {
    const [month, year] = label.split('-').map(Number);
    return year * 100 + month;  // e.g., '05-2025' → 202505
  }

  private destroyCharts(): void {
    this.chartInstances.forEach(chartInstance => {
      chartInstance.destroy();
    });
    this.chartInstances = [];
  }


  selectOverlappingPoint(candidate: any): void {
    this.curvePointData = candidate;
    this.isOverlapChoiceOpen = false;
    this.overlappingCandidates = [];
    this.onOpenMarketCurveFromWidget(true);
  }

  closeOverlapChoice(): void {
    this.isOverlapChoiceOpen = false;
    this.overlappingCandidates = [];
  }

  onOpenMarketCurveFromWidget(value: boolean) {
    this.isMarketCurveOpen = value;
    if (this.isMarketCurveOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  private createAccumulatedData(dataPoints: DataPoint[], sortedLabels: string[]): Map<string, number> {
    const accumulatedMap = new Map<string, number>();

    // Create a map of the original values
    const originalValues = new Map<string, number>();
    dataPoints.forEach(point => {
      originalValues.set(point.month, point.value);
    });

    // Find the starting point month
    const startingPoint = dataPoints.find(point => point.isStartingPoint);
    if (!startingPoint) {
      return accumulatedMap; // Return empty if no starting point
    }

    const startingMonth = startingPoint.month;
    const startingIndex = sortedLabels.indexOf(startingMonth);

    if (startingIndex === -1) {
      return accumulatedMap; // Return empty if starting month not found in labels
    }

    // Accumulate values starting from the starting point
    let runningTotal = 0;

    for (let i = startingIndex; i < sortedLabels.length; i++) {
      const month = sortedLabels[i];

      if (originalValues.has(month)) {
        runningTotal += originalValues.get(month)!;
        accumulatedMap.set(month, Math.round(runningTotal * 100) / 100); // Round to 2 decimals
      }
    }

    return accumulatedMap;
  }

  private getLastAccumulatedValue(month: string, accumulatedMap: Map<string, number>, sortedLabels: string[]): number | null {
    const currentIndex = sortedLabels.indexOf(month);

    // Look backwards for the last accumulated value
    for (let i = currentIndex - 1; i >= 0; i--) {
      const prevMonth = sortedLabels[i];
      if (accumulatedMap.has(prevMonth)) {
        return accumulatedMap.get(prevMonth)!;
      }
    }

    return null;
  }

  /**
   * Get starting month for a dataset
   */
  private getStartingMonth(dataPoints: DataPoint[]): string | null {
    const startingPoint = dataPoints.find(point => point.isStartingPoint);
    return startingPoint ? startingPoint.month : null;
  }

  /**
   * Get current month in YYYY-MM format
   */
  private getCurrentMonth(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  }

  getStartingPoints(apiData: any): StartingPoint[] {
    const startingPoints: StartingPoint[] = [];

    if (apiData.target) {
      const targetStart = apiData.target.find((point: any) => point.isStartingPoint);
      if (targetStart) {
        startingPoints.push({
          type: 'target',
          month: targetStart.month,
          value: targetStart.value
        });
      }
    }

    if (apiData.actual) {
      const actualStart = apiData.actual.find((point: any) => point.isStartingPoint);
      if (actualStart) {
        startingPoints.push({
          type: 'actual',
          month: actualStart.month,
          value: actualStart.value
        });
      }
    }

    return startingPoints;
  }

  private getOverlapThresholdPercent(): number {
    return window.innerWidth < this.OVERLAP_THRESHOLD_BREAKPOINT
      ? this.OVERLAP_THRESHOLD_PERCENT_SMALL
      : this.OVERLAP_THRESHOLD_PERCENT_LARGE;
  }
}
